<template>
  <div>
    <import-page
      title="批量导入核注单"
      :loading="loading"
      :templateUrl="templateUrl"
      :columns="columns"
      :isValid="isValid"
      :limit="1000"
      :previewList="previewList"
      :importLoading="importLoading"
      @on-import="importList"
      @on-preview="previewFile"
    >
    </import-page>
  </div>
</template>

<script>
import ImportPage from "@/components/import-page";
import heZhuApi from "@/api/heZhuApi";
import { CONST_IMPORT_HE_ZHU_TEMPLATE_URL } from "@/config/constant";
export default {
  data() {
    return {
      columns: [
        {
          title: "核注单序号",
          key: "heZhuNo",
          width: 200,
          align: "center",
        },
        {
          title: "账册编号",
          key: "emsNo",
          width: 200,
          align: "center",
        },
        {
          title: "清单类型",
          key: "billType",
          width: 200,
          align: "center",
        },
        {
          title: "经营企业代码",
          key: "bizOpCompanyCode",
          width: 200,
          align: "center",
        },
        {
          title: "收货企业代码",
          key: "rcvCompanyCode",
          width: 100,
          align: "center",
        },
        {
          title: "申报企业代码",
          key: "dclCompanyCode",
          width: 100,
          align: "center",
        },
        {
          title: "监管方式",
          key: "tradeMode",
          width: 100,
          align: "center",
        },
        {
          title: "运输方式",
          key: "transMode",
          width: 100,
          align: "center",
        },
        {
          title: "起运国代码",
          key: "startShipCountry",
          width: 100,
          align: "center",
        },
        {
          title: "关联账册编码",
          key: "rltEmsNo",
          width: 100,
          align: "center",
        },
        {
          title: "关联清单编号",
          key: "rltInvtNo",
          width: 100,
          align: "center",
        },
        {
          title: "商品料号",
          key: "itemNo",
          width: 100,
          align: "center",
        },
        {
          title: "申报数量",
          key: "qty",
          width: 100,
          align: "center",
        },
        {
          title: "校验信息",
          key: "errorMsg",
          align: "center",
          fixed: "right",
          render: (h, params) => {
            const msg = params.row.errorMsg;
            return (
              <div>
                <el-tag type="success" v-show={!msg}>
                  校验成功
                </el-tag>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content={msg}
                  placement="top"
                  v-show={msg}
                >
                  <el-tag type="danger">校验失败</el-tag>
                </el-tooltip>
              </div>
            );
          },
        },
      ],
      loading: false,
      templateUrl: CONST_IMPORT_HE_ZHU_TEMPLATE_URL,
      isValid: false,
      previewList: [],
      importLoading: false,
    };
  },
  components: {
    ImportPage,
  },
  methods: {
    previewFile(fileUrl) {
      if (!fileUrl) {
        this.$message({
          message: "请先上传文件",
          type: "error",
        });
        return;
      }
      if (!/.(xls|xlsx)$/.test(fileUrl)) {
        this.$message({
          message: "您上传的文件格式不正确",
          type: "error",
        });
        return;
      }
      this.loading = true;
      heZhuApi
        .importPreview({
          fileUrl,
        })
        .then((res) => {
          this.previewList = res.value;
          const result = [];
          this.previewList.map((item) => {
            if (item.errorMsg) {
              result.push(item);
            }
          });

          this.isValid = result.length === 0;
          this.loading = false;
        });
    },
    importList() {
      this.importLoading = true;
      heZhuApi
        .batchImport({
          purchaseId: this.$route.params.purchaseId,
          request: JSON.stringify(this.previewList),
        })
        .then((res) => {
          this.importLoading = false;
          if (res.value) {
            this.$message.success("导入成功");
            this.$router.back();
          } else {
            this.$message.error("导入失败");
          }
        })
        .finally(() => {
          this.importLoading = false;
        });
    },
  },
};
</script>
